import React from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import { Button, Form, Table } from "react-bootstrap";
import { Flag } from "react-feather";
import getOnboardingStages from "../../utils/onboardingStages";
import Spinner from 'react-bootstrap/Spinner';

const { REACT_APP_BACKEND_URL } = process.env;


const OnboardingTreatmentModalities = ({stage, token, data}) => {
  var initialValues = {
    treatmentModalities:[]
  };

  if (data && data.treatmentModalities)
  {
    for (var i = 0; i < data.treatmentModalities.length; i++)
    {
      initialValues.treatmentModalities.push(data.treatmentModalities[i]);
    }
  }

  let onboardingStages = getOnboardingStages(data.preferences);

  return (
    <Formik
      enableReinitialize={true}
      initialValues={initialValues}
      validationSchema={Yup.object().shape({
        treatmentModalities: Yup.array().of(
          Yup.object().shape({
            isActive: Yup.boolean()
          })
        )
      })}
      onSubmit={async (values, { setErrors, setStatus, resetForm, setSubmitting }) => {
        try {
          var formData = new FormData();
          formData.append("data", new Blob([JSON.stringify(
            {
              treatmentModalities: values.treatmentModalities
            })], {
              type: "application/json"
          }));

          // No files, but do it the same way so we can keep the backend consistent

          const requestMetadata = {
            method: 'POST',
            body: formData
          };

          const res = await fetch(REACT_APP_BACKEND_URL + "onboarding/" + stage + "/" + token, requestMetadata);

          if (res.status >= 200 && res.status <= 299)
          {
            setStatus({success: true})

            window.location = "/onboarding/" + onboardingStages[onboardingStages.indexOf(stage) + 1] + "/" + token
          }
          else if (res.status === 400)
          {
            setStatus({ success: false });
            alert("Unable to submit; please disable any ad blockers and/or antivirus software and try again. If the problem persists, using a different browser may help.");
            setSubmitting(false);
          }
          else
          {
            throw Error(res.statusText);
          }
        } catch (error) {
          const message = "Something went wrong; please try again";

          setStatus({ success: false });
          alert(message);
          setSubmitting(false);
        }
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        isSubmitting,
        status,
        touched,
        values,
        getFieldProps,
        setFieldValue,
      }) => (
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label style={{fontWeight: "bold"}}>Treatment Modalities</Form.Label>
            <br />
            <Table striped size="sm">
              <thead>
                <tr>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody>
                {values.treatmentModalities.map((treatmentModality, index) => (
                    <tr key={index}>
                      <td style={{paddingBottom: "0px"}}>
                       <Form.Label>
                          <Form.Check style={{display: "inline"}}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            checked={treatmentModality.isActive}
                            name={`treatmentModalities[${index}].isActive`}
                          />
                          &nbsp;&nbsp;
                          {treatmentModality.description}
                        </Form.Label>
                      </td>
                    </tr>
                ))}
                </tbody>
            </Table>
          </Form.Group>
          <br />
          {isSubmitting ?
          <div className="text-center">
             <br />
            <Spinner size="sm" animation="border" />
          </div>
          :
          <>
            <div className="text-center mt-3 float-start">
              <Button size="lg" className="btn-secondary" onClick={() => {window.location = "/onboarding/" + onboardingStages[onboardingStages.indexOf(stage) - 1] + "/" + token}}>Back</Button>
            </div>
            <div id="submitButton" className="text-center mt-3 float-end">
              <Button
                type="submit"
                variant="primary"
                size="lg"
                disabled={isSubmitting}  // Don't check touched, otherwise you end up with this button disabled for, e.g. a peer reference first name missing that has never been touched, so it's not in red; let them click this to touch everything
              >
                Save and Continue
              </Button>
            </div>
          </>
          }
          <br /><br /><br />
          {
            Object.keys(errors).length > 0 && Object.keys(touched).length > 0 &&
            <div className="text-center mt-3"><span className="invalid-feedback" style={{display: "inline-block"}}>Please correct the errors above before moving forward</span></div>
          }
        </Form>
      )}
    </Formik>
  );
}

export default OnboardingTreatmentModalities;
